import { useAuthContext } from "providers/Auth";
import { Layout } from "providers/Layout";
import { useState } from "react";
import { toast } from "react-toastify";
import { UnitsTableView } from "shared/app/UnitsTableView";
import { LayoutButtons } from "shared/app/UnitsTableView/components/LayoutButtons";
import { Redirect } from "shared/components/Redirect";
import { getErrorMessage } from "utils/error";

export const Units = () => {
  const { type, partner } = useAuthContext();

  const [showAddUnitModal, setShowAddUnitModal] = useState(false);

  if (type.isSDK && !type.isBoomScreen) return <Redirect href="/" />;

  return (
    <Layout
      hideFooterForDesktop
      footerClassName="fixed bottom-0 bg-white z-[11] w-full p-4 border-t border-alpha-100"
      footer={
        <div className="flex gap-2">
          <LayoutButtons
            handleCopyLink={async () => {
              try {
                await navigator.clipboard.writeText(
                  partner?.magic_link?.application_link || ""
                );
                toast.info("Link copied");
              } catch (err) {
                toast.error(`Error copying link: ${getErrorMessage(err)}`);
              }
            }}
            setShowAddUnitModal={() => {
              setShowAddUnitModal(true);
            }}
          />
        </div>
      }
    >
      <UnitsTableView showAddUnitModal={showAddUnitModal} />
    </Layout>
  );
};
